import _get from 'lodash/get';
import { Job, JobStatusEnum } from 'graphql-common';
import downloadHandler from '@lib/utils/downloadHandler';

const handleJobCompletion = (
  job: Job,
  downloadedJobIds: string[],
  addOrReplaceDownloadedJobId: (jid: string, downloaded: boolean) => void,
) => {
  const jid = _get(job, 'jid');
  const status = _get(job, 'status');
  const downloadLink = _get(job, 'payload.link');
  const isJobComplete = status === JobStatusEnum.Complete;
  if (jid && !downloadedJobIds.includes(jid) && isJobComplete && downloadLink) {
    downloadHandler(downloadLink);
    addOrReplaceDownloadedJobId(jid, true);
  }
};

export default handleJobCompletion;
